import React, { useEffect,useReducer } from 'react';
import corruptedImg from '../safetyMsg/assets/CORRUPTEDFILE.jpg'
import AsyncCallHandler from '../../../common/AsyncCallHandler'
import sbgDetails from '../../../reducers/sbgDetails';
import { confirm } from 'devextreme/ui/dialog';
import { getTypeOfFile, onDownloadFile } from '../../../common/utils';

const initialState = { sbgData: [], userData: null };

export default ({ data, folderName, moreInfo, onRowUpdating }) => {
    const [state, dispatch] = useReducer(sbgDetails, initialState);

    useEffect(() => {
    }, [data, folderName, moreInfo])

    if (typeof (data) !== 'object') {
        let fileName = data.replace(data.slice(0, data.lastIndexOf('/') + 1), '');

        const deleteFile = () => {
            confirm("Are you sure you want to delete?", "Confirm changes").then((res) => {
                if (res) {
                    let url = `digitaltier/deleteAttachedBlobFile?fileName=${data}&folderName=${folderName}`,
                        method = 'delete';
                    AsyncCallHandler(url, method)
                        .then(res => {
                            if (res) {
                                let key = moreInfo.data.key;
                                moreInfo.data.data.siteImage = "DELETED";
                                moreInfo.data.siteImage = "DELETED";
                                moreInfo.data.data.filePath = "DELETED";
                                moreInfo.data.value = "DELETED";
                                moreInfo.data.newData = { 'siteImage': moreInfo.data.siteImage };
                                moreInfo.data.oldData = moreInfo.data.data;
                                //data = "DELETED";
                                let val = moreInfo.data.data;
                                onRowUpdating({ data: { ...moreInfo.data } })
                            }
                            else { }
                            dispatch({ type: 'FETCH_SITE_LIST', payload: res.data });
                        });
                }
            });
        }
        return data !== 'CORRUPTED'
            ?
            <>
                <a style={{ cursor: 'pointer' }} className="clickable-hover" onClick={() => {
                    getTypeOfFile({ siteImage: fileName, fileExtension: fileName.split('.')[1] }, folderName)
                }}> {moreInfo.data.data.siteImage == "DELETED" ? moreInfo.data.data.siteImage : (moreInfo.data.value == "DELETED" ? moreInfo.data.value : fileName)}</a>&nbsp; &nbsp;&nbsp;
                {((moreInfo.data.value != "DELETED" && moreInfo.data.data.siteImage != "DELETED") || '') && <> <i title="Delete" className="fas fa-trash pointer" onClick={() => deleteFile(data)} ></i>&nbsp; &nbsp;&nbsp;
                    <i title="Download" className="fa fa-download pointer" onClick={() => onDownloadFile(fileName, folderName)}></i></>}
            </>
            : <>
                <img className="alert-img" src={corruptedImg} />
            </>;
    }
    else
        return '';
}